export const COLOR_LEGEND_ASSET_OPTIONS_TAG = 'color_legend_asset_options';
export const COLOR_LEGEND_ASSET_OPTIONS_CONNECTIVITY_WIFI_TAG =
    'color_legend_asset_options_connectivity_wifi';
export const COLOR_LEGEND_ASSET_OPTIONS_CONNECTIVITY_CELLULAR_TAG =
    'color_legend_asset_options_connectivity_cellular';
export const COLOR_LEGEND_ASSET_OPTIONS_CONNECTIVITY_OTHER_TAG =
    'color_legend_asset_options_connectivity_other';
